export const LOGINREQUEST = "LOGINREQUEST";
export const LOGINSUCCESS = "LOGINSUCCESS";
export const LOGINFAILURE = "LOGINFAILURE";

export const GETINVENTORYREQUEST = "GETINVENTORYREQUEST";
export const GETINVENTORYSUCCESS = "GETINVENTORYSUCCESS";
export const GETINVENTORYFAILURE = "GETINVENTORYFAILURE";

export const GETREPORTREQUEST = "GETREPORTREQUEST";
export const GETREPORTSUCCESS = "GETREPORTSUCCESS";
export const GETREPORTFAILURE = "GETREPORTFAILURE";

export const GETFASTAGREQUEST = "GETFASTAGREQUEST";
export const GETFASTAGSUCCESS = "GETFASTAGSUCCESS";
export const GETFASTAGFAILURE = "GETFASTAGFAILURE";

export const GETAGENTSREQUEST = "GETAGENTSREQUEST";
export const GETAGENTSSUCCESS = "GETAGENTSSUCCESS";
export const GETAGENTSFAILURE = "GETAGENTSFAILURE";

export const GETAGENTSNAMESREQUEST = "GETAGENTSNAMESREQUEST";
export const GETAGENTSNAMESSUCCESS = "GETAGENTSNAMESSUCCESS";
export const GETAGENTSNAMESFAILURE = "GETAGENTSNAMESFAILURE";

export const GETINVENTORYDISTRIBUTORREQUEST = "GETINVENTORYDISTRIBUTORREQUEST";
export const GETINVENTORYDISTRIBUTORSUCCESS = "GETINVENTORYDISTRIBUTORSUCCESS";
export const GETINVENTORYDISTRIBUTORFAILURE = "GETINVENTORYDISTRIBUTORFAILURE";

export const GETDISTRIBUTORREQUEST = "GETDISTRIBUTORREQUEST";
export const GETDISTRIBUTORSUCCESS = "GETDISTRIBUTORSUCCESS";
export const GETDISTRIBUTORFAILURE = "GETDISTRIBUTORFAILURE";

export const GETDISTRIBUTORNAMESREQUEST = "GETDISTRIBUTORNAMESREQUEST";
export const GETDISTRIBUTORNAMESSUCCESS = "GETDISTRIBUTORNAMESSUCCESS";
export const GETDISTRIBUTORNAMESFAILURE = "GETDISTRIBUTORNAMESFAILURE";

export const GETINVENTORYAGENTREQUEST = "GETINVENTORYAGENTREQUEST";
export const GETINVENTORYAGENTSUCCESS = "GETINVENTORYAGENTSUCCESS";
export const GETINVENTORYAGENTFAILURE = "GETINVENTORYAGENTFAILURE";

export const GETSTATEREQUEST = "GETSTATEREQUEST";
export const GETSTATESUCCESS = "GETSTATESUCCESS";
export const GETSTATEFAILURE = "GETSTATEFAILURE";

export const GETCITYREQUEST = "GETCITYREQUEST";
export const GETCITYSUCCESS = "GETCITYSUCCESS";
export const GETCITYFAILURE = "GETCITYFAILURE";

export const SENDOTPREQUEST = "SENDOTPREQUEST";
export const SENDOTPSUCCESS = "SENDOTPSUCCESS";
export const SENDOTPFAILURE = "SENDOTPFAILURE";

export const CHANGEPASSWORDREQUEST = "CHANGEPASSWORDREQUEST";
export const CHANGEPASSWORDSUCCESS = "CHANGEPASSWORDSUCCESS";
export const CHANGEPASSWORDFAILURE = "CHANGEPASSWORDFAILURE";

export const EDITDISTRIBUTORREQUEST = "EDITDISTRIBUTORREQUEST";
export const EDITDISTRIBUTORSUCCESS = "EDITDISTRIBUTORSUCCESS";
export const EDITDISTRIBUTORFAILURE = "EDITDISTRIBUTORFAILURE";

export const LOGOUT = "LOGOUT";

export const GETMASTERFASTAGREQUEST = "GETMASTERFASTAGREQUEST";
export const GETMASTERFASTAGSUCCESS = "GETMASTERFASTAGSUCCESS";
export const GETMASTERFASTAGFAILURE = "GETMASTERFASTAGFAILURE";

export const GETALLAGENTSNAMESREQUEST = "GETALLAGENTSNAMESREQUEST";
export const GETALLAGENTSNAMESSUCCESS = "GETALLAGENTSNAMESSUCCESS";
export const GETALLAGENTSNAMESFAILURE = "GETALLAGENTSNAMESFAILURE";

export const GETINVENTORYSUMMARYREQUEST = "GETINVENTORYSUMMARYREQUEST";
export const GETINVENTORYSUMMARYSUCCESS = "GETINVENTORYSUMMARYSUCCESS";
export const GETINVENTORYSUMMARYFAILURE = "GETINVENTORYSUMMARYFAILURE";

export const CREATEDISTRIBUTORBULKREQUEST = "CREATEDISTRIBUTORBULKREQUEST";
export const CREATEDISTRIBUTORBULKSUCCESS = "CREATEDISTRIBUTORBULKSUCCESS";
export const CREATEDISTRIBUTORBULKFAILURE = "CREATEDISTRIBUTORBULKFAILURE";

export const CREATEAGENTBULKREQUEST = "CREATEAGENTBULKREQUEST";
export const CREATEAGENTBULKSUCCESS = "CREATEAGENTBULKSUCCESS";
export const CREATEAGENTBULKFAILURE = "CREATEAGENTBULKFAILURE";

export const GETDISTRIBUTORSUMMARYREQUEST = "GETDISTRIBUTORSUMMARYREQUEST";
export const GETDISTRIBUTORSUMMARYSUCCESS = "GETDISTRIBUTORSUMMARYSUCCESS";
export const GETDISTRIBUTORSUMMARYFAILURE = "GETDISTRIBUTORSUMMARYFAILURE";

export const GETDISTRIBUTORAGENTSUMMARYREQUEST = "GETDISTRIBUTORAGENTSUMMARYREQUEST";
export const GETDISTRIBUTORAGENTSUMMARYSUCCESS = "GETDISTRIBUTORAGENTSUMMARYSUCCESS";
export const GETDISTRIBUTORAGENTSUMMARYFAILURE = "GETDISTRIBUTORAGENTSUMMARYFAILURE";

export const GETAGENTSUMMARYREQUEST = "GETAGENTSUMMARYREQUEST";
export const GETAGENTSUMMARYSUCCESS = "GETAGENTSUMMARYSUCCESS";
export const GETAGENTSUMMARYFAILURE = "GETAGENTSUMMARYFAILURE";

export const GETDISTRIBUTORREQUESTREQUEST = "GETDISTRIBUTORREQUESTREQUEST";
export const GETDISTRIBUTORREQUESTSUCCESS = "GETDISTRIBUTORREQUESTSUCCESS";
export const GETDISTRIBUTORREQUESTFAILURE = "GETDISTRIBUTORREQUESTFAILURE";

export const ASSIGNAGENTEXCELREQUEST = "ASSIGNAGENTEXCELREQUEST";
export const ASSIGNAGENTEXCELSUCCESS = "ASSIGNAGENTEXCELSUCCESS";
export const ASSIGNAGENTEXCELFAILURE = "ASSIGNAGENTEXCELFAILURE";

export const GETALLFASTAGAGENTREQUESTREQUEST = "GETALLFASTAGAGENTREQUESTREQUEST";
export const GETALLFASTAGAGENTREQUESTSUCCESS = "GETALLFASTAGAGENTREQUESTSUCCESS";
export const GETALLFASTAGAGENTREQUESTFAILURE = "GETALLFASTAGAGENTREQUESTFAILURE";

export const GETAGENTFASTAGREQUEST = "GETAGENTFASTAGREQUEST";
export const GETAGENTFASTAGSUCCESS = "GETAGENTFASTAGSUCCESS";
export const GETAGENTFASTAGFAILURE = "GETAGENTFASTAGFAILURE";

export const UPDATEAGENTREQUESTSTATUSREQUEST = "UPDATEAGENTREQUESTSTATUSREQUEST";
export const UPDATEAGENTREQUESTSTATUSSUCCESS = "UPDATEAGENTREQUESTSTATUSSUCCESS";
export const UPDATEAGENTREQUESTSTATUSFAILURE = "UPDATEAGENTREQUESTSTATUSFAILURE";

export const DENIEDREQUESTSTATUSREQUEST = "DENIEDREQUESTSTATUSREQUEST";
export const DENIEDREQUESTSTATUSSUCCESS = "DENIEDREQUESTSTATUSSUCCESS";
export const DENIEDREQUESTSTATUSFAILURE = "DENIEDREQUESTSTATUSFAILURE";

export const ASSIGNDISTRIBUTOREXCELREQUEST = "ASSIGNDISTRIBUTOREXCELREQUEST";
export const ASSIGNDISTRIBUTOREXCELSUCCESS = "ASSIGNDISTRIBUTOREXCELSUCCESS";
export const ASSIGNDISTRIBUTOREXCELFAILURE = "ASSIGNDISTRIBUTOREXCELFAILURE";

export const GET_AGENTS_DISTRIBUTOR_WISE_REQUEST = "GET_AGENTS_DISTRIBUTOR_WISE_REQUEST";
export const GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS = "GET_AGENTS_DISTRIBUTOR_WISE_SUCCESS";
export const GET_AGENTS_DISTRIBUTOR_WISE_FAILURE = "GET_AGENTS_DISTRIBUTOR_WISE_FAILURE";

export const REFRESH_DATA = "REFRESH_DATA";

